<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router'
import { useServiceStore } from '@/stores/serviceStore';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useRequestsStore } from '@/stores/storeRequests';
import ServiceNotProduct from '@/components/services_view/ServiceNotProduct.vue';
import Loader from '@/components/ui/Loader.vue';

const storeService = useServiceStore();
const storeField = useFieldsStore();
const storeRequests = useRequestsStore();
const router = useRouter()

const isScreenLoading = computed(() => !storeRequests.isProductsLoaded)

const nextSreenRentalInventory = async () => {
    storeService.goToScreen(storeService.screens.rentalInventory)
    router.push({ hash: `#${storeService.screens.rentalInventory}`})
}
const nextSreenRentalCourt = async () => {
    storeService.goToScreen(storeService.screens.rentalCourt)
    router.push({ hash: `#${storeService.screens.rentalCourt}`})
}

const previousSreen = () => {
    storeService.goToScreen(storeService.screens.authUserData)
    storeRequests.responseError = null
    router.push({ hash: `#${storeService.screens.authUserData}`})
}

</script>
<template>
    <div class="container">
        <div class="services-container">
            <button class="services-btn-back" @click="previousSreen" v-if="!storeRequests.isAuthenticated">
                <svg width='24' height='24'><use href='#back_icon'></use></svg>
                <span>Назад</span>
            </button>
            <h2 class="service-title">Услуги</h2>
            <Loader v-if="isScreenLoading"/>
            <template v-else>
                <div class="service" v-if="storeRequests.isNotProduct">
                    <div class="service__container">
                        <div class="service__item" v-if="storeRequests.listCourts" @click="nextSreenRentalCourt">
                            <div class="service__image">
                                <img class='full-img' width='670' height='426' src='@/assets/img/services/service_1.jpg' alt='изображение'>
                            </div>
                            <div class="service__footer">
                                <div class="service__name">Аренда игровых площадок</div>
                                <div class="service__btn">Подробнее</div>
                            </div>
                        </div>
                        <div class="service__item" v-if="storeRequests.listQuipments" @click="nextSreenRentalInventory">
                            <div class="service__image">
                                <img class='full-img' width='670' height='426' src='@/assets/img/services/service_2.jpg' alt='изображение'>
                            </div>
                            <div class="service__footer">
                                <div class="service__name">Аренда инвентаря</div>
                                <div class="service__btn">Подробнее</div>
                            </div>
                        </div>
                    </div>
                </div>
                <ServiceNotProduct v-else />
            </template>
            
        </div>
    </div>
</template>
<style lang='scss' scoped>
</style>